import { makeStyles } from "@material-ui/styles"
import { color } from "app/ui/Theme/colors"

export default makeStyles({
  rightContainer: {
    gridColumn: "2/3",
    background: color.darkred,
    height: "35rem",
    alignSelf: "flex-end",
    clipPath: "polygon(0 0,10.5rem 0,16.5rem 5rem,100% 5rem,100% 100%,0 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ["@media (max-width:740px)"]: {
      gridRow: "2/3",
      gridColumn: "1/2",
      transform: "translateY(-5.5rem)",
      zIndex: 1,
    },
  },
  rightBlock: {
    width: "100%",
    height: "100%",
    transform: "scale(0.96)",
    background: color.red,
    clipPath:
      "polygon( 0 0, 10.5rem 0, 16.5rem 5rem, 100% 5rem, 100% 100%, 0 100% )",
    borderRadius: "0 0 5px 3px",
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gridTemplateRows: "repeat(auto, max-content)",
    gridGap: "1rem 2rem",
    padding: "7rem 3.5rem 2rem 3.5rem",
  },
  rightBlackScreen: {
    background: color.black,
    borderRadius: "3px",
    gridColumn: "1/-1",
    padding: "1rem 2rem",
    color: color.grey,
    display: "grid",
    gridTemplateColumns: "47% 47%",
    gridTemplateRows: "1fr 1fr 1fr",
    alignItems: "center",
    gridGap: "6%",
  },
  blueGrid: {
    gridColumn: "1/-1",
    height: "4rem",
    borderRadius: "3px",
    border: `1px solid ${color.darkgrey}`,
    boxShadow: `0 1px 1px ${color.darkgrey}`,
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gridTemplateRows: "1fr 1fr",
  },
  blueGridCell: {
    background: color.lightblue,
    borderRight: `1px solid ${color.darkgrey}`,
    borderBottom: `1px solid ${color.darkgrey}`,
    cursor: "pointer",
  },
  listImage: {
    width: "100%",
  },
  navButtons: {
    gridRow: "6/6",
    width: "100%",
    height: "2rem",
    background: color.black,
    borderRadius: "3px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: color.grey,
    cursor: "pointer",
    transition: "all 0.2s",
  },
})
